
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./pagestyles/BottomBanner.css";

// import React, { useEffect, useState } from "react";
// import "./pagestyles/BottomBanner.css";

// const BottomBanner = () => {
//   const [visible, setVisible] = useState(false);

//   useEffect(() => {
//     // Small delay so it animates after page loads
//     const timer = setTimeout(() => {
//       setVisible(true);
//     }, 100);

//     return () => clearTimeout(timer);
//   }, []);

//   return (
//     <div className={`bottom-banner ${visible ? "show" : ""}`}>
//       <div className="banner-content">
//         <h2>Get unlimited access for just $1.99 your first month</h2>
//         <p>Unlock the global benchmark for business news.</p>
//         <button className="claim-btn">Claim This Offer</button>
//       </div>

//       <button className="close-btn" onClick={() => setVisible(false)}>
//         ✕
//       </button>
//     </div>
//   );
// };

// export default BottomBanner;



// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./pagestyles/BottomBanner.css";

const BottomBanner = () => {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate(); // ✅ Add this

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // ✅ Handle button click
  const handleClaimClick = () => {
    navigate("/subscriptions/checkout");
  };

  return (
    <div className={`bottom-banner ${visible ? "show" : ""}`}>
      <div className="banner-content">
        <h2>Get unlimited access for just $1.99 your first month</h2>
        <p>Unlock the global benchmark for business news.</p>

        {/* ✅ Added onClick */}
        <button 
          className="claim-btn"
          onClick={handleClaimClick}
        >
          Claim This Offer
        </button>
      </div>

      {/* <button 
        className="close-btn" 
        onClick={() => setVisible(false)}
      >
        ✕
      </button> */}
    </div>
  );
};

export default BottomBanner;

